(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
// A1 2026-10-06: adds from the You may also like carousel carry _added_via so the weekly report can attribute them.
(function(){
  document.addEventListener('click', function(evt){
    var btn = evt.target.closest && evt.target.closest('.quickbuy-toggle');
    if(!btn || !btn.closest('.related-products')) return;
    var block = btn.closest('product-block'); var directId = block && parseInt(block.dataset.firstVariant, 10);
    if(!directId) return;
    evt.preventDefault(); evt.stopPropagation();
    if(btn.dataset.hewynAdding) return; btn.dataset.hewynAdding='1'; var t=btn.textContent; btn.textContent='…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:directId,quantity:1,properties:{_added_via:'ymal-carousel'}})})
      .then(function(r){ if(!r.ok) throw new Error('cart add '+r.status); return r.json(); })
      .then(function(){ btn.textContent='Added'; document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('cart-drawer:open')); setTimeout(function(){ btn.textContent=t; delete btn.dataset.hewynAdding; },2500); })
      .catch(function(){ btn.textContent=t; delete btn.dataset.hewynAdding; window.location.href=btn.href; });
  }, true);
})();
var loadProductRecommendationsIntoSection = function() {
  // A1 2026-10-05: curated complementary pairs first (Search & Discovery metafield), then Shopify
  // related products fill the remaining slots up to the section's "Maximum products" setting.
  var section = document.querySelector(".related-products");
  if (section === null) { return; }
  var limit = parseInt(section.dataset.limit || "4", 10);
  var fetchHtml = function(url, cb) {
    var request = new XMLHttpRequest();
    request.open("GET", url);
    request.onload = function() { cb(request.status >= 200 && request.status < 300 ? request.response : ""); };
    request.onerror = function() { cb(""); };
    request.send();
  };
  var parse = function(html) {
    var container = document.createElement("div");
    container.innerHTML = html;
    return container.querySelector(".related-products");
  };
  var keyOf = function(block) {
    var a = block.querySelector("a[href*='/products/']");
    return a ? a.getAttribute("href").split("?")[0] : block.innerText.slice(0, 40);
  };
  fetchHtml(section.dataset.url, function(compHtml) {
    var comp = parse(compHtml);
    var compBlocks = comp ? Array.prototype.slice.call(comp.querySelectorAll(".product-block")) : [];
    fetchHtml(section.dataset.urlFallback, function(relHtml) {
      var rel = parse(relHtml);
      var relBlocks = rel ? Array.prototype.slice.call(rel.querySelectorAll(".product-block")) : [];
      var base = compBlocks.length ? comp : rel;
      if (!base) { return; }
      var grid = base.querySelector(".product-grid");
      var seen = {};
      var merged = [];
      // A1 2026-10-08 (Cemre): never pad our pairs with Shopify "related" items, they bring a second
      // scale or whey next to the seed. Related is only the fallback when a product has no pairs.
      compBlocks.concat(compBlocks.length ? [] : relBlocks).forEach(function(b) {
        var k = keyOf(b);
        if (seen[k] || merged.length >= limit) { return; }
        seen[k] = true; merged.push(b);
      });
      if (grid) {
        grid.innerHTML = "";
        merged.forEach(function(b) { grid.appendChild(b); });
      }
      section.innerHTML = base.innerHTML;
      section.dataset.source = compBlocks.length ? "complementary" : "related";
      section.dataset.count = String(merged.length);
    });
  });
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
